import { render, staticRenderFns } from "./SecondaryButton.vue?vue&type=template&id=063b0f52&scoped=true&"
import script from "./SecondaryButton.vue?vue&type=script&setup=true&lang=ts&"
export * from "./SecondaryButton.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./SecondaryButton.vue?vue&type=style&index=0&id=063b0f52&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063b0f52",
  null
  
)

export default component.exports